import { apiGetAccountCard } from "api/reportApi";
import BasicButton from "components/BasicInputs/BasicButton";
import { formatPrice } from "helpers";
import useDateState from "helpers/useDateState";
import { use } from "packages/swiper/swiper-bundle";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import ReactToPrint from "react-to-print";
import { useAppSelector } from "store/store";

const AccountCardPrint = ({ fromDate, toDate }: { toDate?: string, fromDate?: string }) => {
    const ref = useRef(null)
    const [data, setData] = useState<any>(null)
    const store = useAppSelector((x: any) => x);
    const pagination = store.paginationReducer;
    const { token ,fiscalYearStartDate,fiscalYeaEndDate} = store.businessReducer.business;
    const businessnickName = store.businessReducer.business.business.nickName
    const dispatch = useDispatch()
    useEffect(() => {
        if (data != null) {
            const element = document.getElementById("toPrintAccountCard")
            element?.click()
        }

        return () => {

        }
    }, [data])

    const getData = () => {
        let { search, sort } = pagination;
        let data: any = {};
        if (fromDate && toDate) {
            data.column = "createdAt";
            data.columnType = "date";
            data.primarySearch = fromDate;
            data.secondarySearch = toDate
            data.filterType = "7";
        }
        //@ts-ignore
        dispatch(apiGetAccountCard({ pagination: { ...pagination, limit: 'all' }, search, sort, token, options: data, params: {}, callBack: (res: any) => setData(res) }));
    }
    if (data) {
        const person = { ...data?.data?.person }
        const Accounting_Items = [...data.data.Accounting_Items]
        const currentDate = new Date()
        const persianDate = new Intl.DateTimeFormat('fa-IR').format(currentDate)
        const sumAmount = data.data.sumAmountFinal
        const [Sumcreditor, Sumdebtor] = sumAmount

        return (
            <>

                <BasicButton onClick={getData} fullWidth variant="outlined">
                    <span>چاپ گزارش</span>
                </BasicButton>

                <div className="hidden">
                    <div ref={ref} className="m-7">
                        <div className="flex text-center justify-center">
                            {businessnickName}
                        </div>
                        <div className="bg-gray-300 " dir="rtl">
                            <div className="flex gap-5 justify-between p-3">
                                <div className="flex gap-4 w-1/3">
                                    <span className="font-bold">کد شخص:</span>
                                    <span>{person.accountingCode}</span>
                                </div>

                                <div className="flex gap-4 w-1/3">
                                <span className="font-bold">مانده</span>
                                    {
                                        person.totalBalance === 0 ? "تراز" : person.totalBalance > 0 ? "بستانکار" : "بدهکار"
                                    }

                                    {person.totalBalance > 0 || person.totalBalance < 0 ? formatPrice(person.totalBalance) : ""}
                                </div>
                                <div className="flex gap-4 w-1/3">
                                    <span className="font-bold">تاریخ گزارش:</span>
                                    <span>{persianDate}</span>
                                </div>


                            </div>
                            <div className="flex gap-5 justify-between p-3">
                                <div className="flex gap-4 w-5/6">
                                    <span className="font-bold">شخص:</span>
                                    <span>{person.nickName}</span>
                                </div>
                                <div className="flex gap-4 w-1/6">
                                    <span className="font-bold">از تاریخ:</span>
                                    <span>{fromDate ? fromDate : fiscalYearStartDate}</span>
                                </div>
                                <div className="flex gap-4 w-1/6">
                                    <span className="font-bold">تا تاریخ:</span>
                                    <span>{toDate ? toDate : fiscalYeaEndDate}</span>
                                </div>


                            </div>
                        </div>
                        <div className="overflow-x-auto">
                            <table dir="rtl" className="min-w-full  bg-white border border-gray-300">
                                <thead>
                                    <tr className="bg-gray-200 text-gray-700 text-center">
                                        <th className="border border-black px-4 py-2">ردیف</th>
                                        <th className="border border-black px-4 py-2">شماره </th>
                                        <th className="border border-black px-4 py-2">نوع</th>
                                        <th className="border border-black px-4 py-2">تاریخ</th>
                                        <th className="border border-black px-4 py-2">گردش بدهکار</th>
                                        <th className="border border-black px-4 py-2">گردش بستانکار</th>
                                        <th className="border border-black px-4 py-2">مانده بدهکار</th>
                                        <th className="border border-black px-4 py-2">مانده بستانکار</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Accounting_Items.map((row, ix) => {

                                        return <tr key={ix} className="bg-white text-center">
                                            <td className="border border-black px-4 py-2">{ix + 1}</td>
                                            <td className="border border-black px-4 py-2">{row.accountingCode}</td>
                                            <td className="border border-black px-4 py-2">{row.accountingType}</td>
                                            <td className="border border-black px-4 py-2">{row.date}</td>
                                            <td className="border border-black px-4 py-2">{formatPrice(row.debtor)}</td>
                                            <td className="border border-black px-4 py-2">{formatPrice(row.creditor)}</td>
                                            <td className="border border-black px-4 py-2">{row.balance < 0 ? formatPrice(row.balance) : 0}</td>
                                            <td className="border border-black px-4 py-2">{row.balance > 0 ? formatPrice(row.balance) : 0}</td>
                                        </tr>


                                    })}

                                    <tr key={'sum'} className="bg-white text-center">
                                        <td colSpan={2} className="border px-4 py-2">جمع</td>
                                        <td className="border px-4 py-2"> </td>
                                        <td className="border px-4 py-2"></td>
                                        <td className="border px-4 py-2">{formatPrice(Sumdebtor.debtor)}</td>
                                        <td className="border px-4 py-2">{formatPrice(Sumcreditor.creditor)}</td>
                                        <td className="border px-4 py-2"></td>
                                        <td className="border px-4 py-2"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <ReactToPrint
                    trigger={() => <div id="toPrintAccountCard"></div>}
                    content={() => ref.current}
                />
            </>
        );

    }
    return <BasicButton onClick={getData} fullWidth variant="outlined">
        <span>چاپ گزارش</span>
    </BasicButton>
}

export default AccountCardPrint;